import { NavLink, useLocation } from "react-router-dom";
import "./Footer.css";

const Footer = ({ classN }) => {
  let currentYear = new Date().getFullYear();
  // get last part of the url
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const ref = params.get("ref");
  const excludedRefs = [
    "privacy-policy",
    "end-user-license-agreement",
    "terms-of-service",
  ];
  let lastPart;
  if (ref && !excludedRefs.includes(ref)) {
    lastPart = ref;
  } else if (location.pathname === "/login") {
    lastPart = "home";
  } else {
    lastPart = location.pathname.split("/")[1];
  }

  return (
    <footer className={`footer-c ${classN}`}>
      <div className="cpr-fot">
        <span>{`Copyright © ${currentYear} QR STUDIO AI`}</span>
      </div>
      <div className="terCon-foot">
        <NavLink
          to={`/terms-of-service?ref=${lastPart}`}
          className="link-te-foo"
        >
          {"Terms of Service"}
        </NavLink>
        <span className="link-te-foo">|</span>
        <NavLink to={`/privacy-policy?ref=${lastPart}`} className="link-te-foo">
          {"Privacy Policy"}
        </NavLink>
      </div>
    </footer>
  );
};

export default Footer;
